module.exports = __webpack_public_path__ + "static/media/studio-ai-logo.11b51c94.png";